import React from "react";
import { Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const ReviewsEmptyState: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Paper sx={{ p: 4, textAlign: "center" }}>
      <Typography variant="h6" color="text.secondary">
        {t("admin.sellerReviews.noReviewsFound", {
          defaultValue: "No seller reviews found yet.",
        })}
      </Typography>
    </Paper>
  );
};

export default ReviewsEmptyState;